import { useState } from "react";
import { Info } from "lucide-react";

/**
 * InfoTooltip — standard ℹ icon with hover tooltip.
 * BRD Section 5.5: mandatory on specified metrics.
 */
export default function InfoTooltip({ text, size = 11 }) {
  const [show, setShow] = useState(false);
  return (
    <span className="relative inline-flex items-center">
      <button
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        className="text-slate-500 hover:text-slate-500 transition-colors focus:outline-none"
        aria-label="More information"
      >
        <Info size={size} />
      </button>
      {show && (
        <span className="absolute bottom-full right-0 mb-2 z-50
          w-64 bg-slate-800 text-white text-xs rounded-lg px-3 py-2 shadow-xl leading-relaxed
          pointer-events-none">
          {text}
          <span className="absolute top-full right-4 border-4 border-transparent border-t-slate-800" />
        </span>
      )}
    </span>
  );
}
